import React, { useState, useEffect } from "react";
import { useNavigate,  Link } from "react-router-dom";
import Layout from "../components/layout";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import productsList from "../data/products.json";
import { Helmet } from "react-helmet-async";

function Products() {

    const [show, setShow] = useState(false);

    const [enquireShow, setEnquireShow] = useState(false);

    const handleShow = () => setShow(true);

    const handleEnquireShow = () => {
        setEnquireShow(true);
        setFullName("");
        setEmail("");
        setMessage("");
        setMobileNo("");
        setErrorMessage("");
    }
    const handleEnquireClose = () => setEnquireShow(false);

    const [fullName, setFullName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [mobileNo, setMobileNo] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [message, setMessage] = React.useState("");

    const [errorMessage, setErrorMessage] = React.useState("");

    const [productName, setProductName] = React.useState("");
    const [refreshURL, setRefreshURL] = React.useState("");
    const [resetKey, setResetKey] = React.useState(0);

    return (
        <>
        <Helmet>
                    <title>Products | Adilite Group</title>
        
                    <meta name="description" content="Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research." />
                    <meta
                    name="keywords"
                    content="Power Transformer, Electrical Equipment, Transformer, Secure Meters"
                    />
                    <meta name="robots" content="index,follow" />
        
                    <link rel="canonical" href="https://www.adilitegroups.com/products" />
        
                    {/* Open Graph */}
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="Products | Adilite Group" />
                    <meta property="og:description" content="Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research." />
                    <meta property="og:url" content="https://www.adilitegroups.com/products" />
                </Helmet>
        <Layout>
            <div>
                <div id="banner-area" className="banner-area" style={{ backgroundImage: 'url(assets/images/banner/banner1.jpg)' }}>
                    <div className="banner-text">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="banner-heading">
                                        <h1 className="banner-title">Products</h1>
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb justify-content-center">
                                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                                <li className="breadcrumb-item"><a href="/">ADILITE GROUP</a></li>
                                                <li className="breadcrumb-item active" aria-current="page">Products</li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>{/* Col end */}
                            </div>{/* Row end */}
                        </div>{/* Container end */}
                    </div>{/* Banner text end */}
                </div>{/* Banner area end */}
                <section id="main-container" className="main-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Container>
                                    <Row className="justify-content-md-center">
                                        {productsList.map((item, index) => (
                                            <Col>
                                                <Card style={{ width: '18rem', margin: 20, boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                                                    <img src={item.ImageFilePath} height="200px" style={{ objectFit: 'contain', margin: 10 }} />
                                                    <Card.Body style={{ textAlign: "center" }}>
                                                    <Card.Title style={{ textAlign: 'center' }}><Link to={`/${item.ProductName.replaceAll(" ","-")}`} title={item.ProductName}>{item.ProductName}</Link></Card.Title>
                                                        <Card.Text style={{ textAlign: 'center' }}>
                                                            {item.ProductDesc}
                                                        </Card.Text>
                                                        <Button variant="outline-primary" size="sm" onClick={()=>{
                                                            setSubject(item.ProductName);
                                                            handleEnquireShow();
                                                        }}>Enquire Now</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <Button variant="outline-primary" size="sm" onClick={() => {
                                                            setProductName(item.ProductName);
                                                            setResetKey(resetKey + 1);
                                                            setRefreshURL(item.DocFilePath);
                                                            handleShow();
                                                        }}>Preview</Button>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                        )}
                                    </Row>
                                </Container>
                            </div>{/* Col end */}
                        </div>{/* Content row end */}
                    </div>{/* Container end */}
                </section>{/* Main container end */}

            </div>
            <Modal show={show} onHide={() => setShow(false)} centered dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">{productName}</Modal.Title>
                </Modal.Header>
                <Modal.Body><iframe key={resetKey} src={refreshURL} width="100%" height="400px" /></Modal.Body>                
            </Modal>
            <Modal show={enquireShow} onHide={() => setEnquireShow(false)} centered dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">Enquire Now</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between' }}>
                        <Form.Group>
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control value={fullName} onChange={(e)=>setFullName(e.target.value)} type="text" placeholder="Enter your full name" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Email</Form.Label>
                            <Form.Control value={email} onChange={(e)=>setEmail(e.target.value)} type="email" placeholder="Enter your email" />
                        </Form.Group>
                    </div>
                    <br/>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between' }}>
                        <Form.Group>
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control value={mobileNo} onChange={(e)=>setMobileNo(e.target.value)} type="text" placeholder="Enter your mobile no." />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control value={subject} onChange={(e)=>setSubject(e.target.value)} type="text" placeholder="Enter product name" />
                        </Form.Group>
                    </div>
                    <br/>
                    <div>
                        <Form.Group>
                            <Form.Label>Message</Form.Label>
                            <Form.Control value={message} onChange={(e)=>setMessage(e.target.value)} as="textarea" rows={3} placeholder="Enter your message" />
                        </Form.Group>                        
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleEnquireClose} variant="secondary">Close</Button>
                    <Button variant="primary" onClick={()=>{
                        if(fullName !== "" && email !== "" && subject !== "" && message !== "" && mobileNo !=="")
                        {
                            const phone = "919000123060"; // Country code + phone number (no + or spaces)
                            
                            const whatsappMessage = `*New Contact Inquiry*\n\n*Name:* ${fullName}\n*Email:* ${email}\n*Mobile No:* ${mobileNo}\n*Subject:* ${subject}\n*Message:* ${message}`;

                            const url = `https://wa.me/${phone}?text=${encodeURIComponent(whatsappMessage)}`;

                            window.open(url, "_blank");

                            setEnquireShow(false);
                        }
                        else
                        {
                            setErrorMessage("Enter all valid fields.");
                        }
                    }}>Submit</Button>
                    <div style={{color:"#FF0000"}}>
                    {errorMessage}
                    </div>
                </Modal.Footer>
            </Modal>
            <h5 style={{ color: "#fff", fontSize: 0.1 }}>
                Welcome to Adilite Group, the leading provider of high-quality measurement and testing products. We specialize in offering a comprehensive range of instruments and tools designed to meet the need of various industries, including manufacturing, construction, engineering and research.
                Testing instruments, Measuring instruments, Measurement tools, Testing equipment, Calibration equipment, Specific Instrument Keywords,Multimeters,Oscilloscopes,Pressure gauges,Thermometers, Anemometers, Calipers,pH meters,Data loggers,Spectrum analyzers, Electrical testing instruments, HVAC measuring tools, Laboratory testing equipment, Industrial measurement devices, Environmental testing instruments,Precision measuring instruments,Digital testing tools,Analog measurement tools,Portable testing equipment,Handheld measuring devices,Fluke testing instruments,Extech measuring tools,Tektronix oscilloscopes,Mitutoyo calipers,Keysight measurement devices,High accuracy testing instruments,Wireless measuring devices,Waterproof measuring tools,Multifunction testing equipment, User-friendly measurement tools, How to measure voltage, Best tools for measuring pressure, Accurate temperature measurement devices, Reliable pH testing equipment, Affordable testing instruments, Testing instruments suppliers near me, Measuring tools dealer in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam, Local calibration equipment services, Nearest industrial testing instruments store, Find pH meters in hyderabad, andhra pradesh, telangana, bangalore, mumbai, pune, vijaywada, vishakhapatnam
                Authorised Secure dealer of APEX 100,Apex 150_R01,Elite 100 & 300 MFM New,Elite 440 New,Elite 500 -Power Monitoring Meter,Liberty 170,Liberty 370,M-cubed_100,premier_300,Prodigy new,ProQ_100,PT1_single function transducer,Saral, saral-300, sprint 350, summator 100, transducerPT1-multi, transducerPT3-multi
            </h5>
        </Layout>
        </>
    );
}

export default Products;
